import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('MostExpensiveItem').create(({ theme }) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',

    paddingBottom: '64px',
  },

  listItem: {
    display: 'flex',
    height: 'fit-content',
    gap: '12px',
  },

  iconWrapper: {
    display: 'flex',
    gap: '4px',
  },

  topAndBottomWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flexGrow: 1,
  },

  heading: {
    fontWeight: 370,
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    textAlign: 'left',
    width: '100%',
    textTransform: 'uppercase',
    color: theme.colors.text.secondary,
  },

  gameTitle: {
    fontSize: theme.sizes.texts.fontSize.xs,
    fontWeight: 370,
  },

  bottomContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  img: {
    width: '95px',
    padding: '4px 12px',
    height: 'auto',
    background: 'linear-gradient(180deg, #0E0E0E 0%, #747474 100%)',
    border: '1px solid transparent',
  },

  itemTitle: {
    fontWeight: 350,
    fontSize: '13px',
    lineHeight: '18px',
  },

  itemScoreDiff: {
    display: 'flex',
    flexWrap: 'wrap',
    background: 'rgba(96, 125, 252, 0.2)',
    borderRadius: '12px',
    paddingRight: '2px',
    paddingLeft: '6px',
    maxHeight: '20px',
    alignItems: 'center',
    gap: '4px',

    span: {
      fontFamily: 'Space Grotesk',
      fontWeight: 470,
      fontSize: '18px',
      lineHeight: theme.sizes.texts.lineHeight.m,
    },
  },

  coinIcon: {
    width: '16px',
    height: '16px',
  },
}))
